import { Link } from 'react-router-dom';

export default function FeaturedTreatments() {
  const treatments = [
    {
      name: 'Hydration IV',
      price: '$209',
      description: 'Electrolytes and fluids for deep hydration and recovery.',
      image: 'https://public.readdy.ai/ai/img_res/01025f281a4047bc45528415e015a5e0.jpg',
    },
    {
      name: 'Hangover Relief IV',
      price: '$299',
      description: 'IV fluids, B-complex vitamins, and anti-nausea medication.',
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20golden%20yellow%20vitamin%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_hangover_club_01&orientation=portrait',
    },
    {
      name: 'Headache Relief IV',
      price: '$399',
      description: 'Magnesium, hydration fluids, and medications to relieve migraine symptoms.',
      image: 'https://readdy.ai/api/search-image?query=transparent%20medical%20grade%20IV%20drip%20bag%20filled%20with%20soft%20lavender%20purple%20fluid%20with%20dark%20black%20rectangular%20label%20panel%20printed%20with%20white%20text%20IV%20HYDRATION%20CLUB%20hanging%20against%20pure%20white%20studio%20background%20professional%20product%20photography%20clean%20minimalist%20lighting%20clear%20tubing%20attached&width=480&height=640&seq=ivbag_headache_club_01&orientation=portrait',
    },
  ];

  return (
    <section className="py-28 px-6 lg:px-12 bg-white">
      <div className="max-w-6xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-5">
            Our Services
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-charcoal tracking-tight mb-5">
            IV Treatments
          </h2>
          <div className="w-16 h-px bg-gold mx-auto"></div>
        </div>

        {/* Treatments Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#e8e2da]">
          {treatments.map((treatment, index) => (
            <div
              key={index}
              className="bg-white flex flex-col items-center text-center px-10 pt-14 pb-12 group hover:bg-[#faf9f7] transition-colors duration-300"
            >
              {/* IV Bag Image */}
              <div className="w-full flex items-center justify-center mb-10" style={{ height: '280px' }}>
                <img
                  src={treatment.image}
                  alt={treatment.name}
                  className="h-full w-auto object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Gold accent */}
              <div className="w-8 h-px bg-gold mb-6"></div>

              {/* Name */}
              <h3 className="text-xs font-light tracking-[0.25em] uppercase text-charcoal mb-3">
                {treatment.name}
              </h3>

              {/* Price */}
              <p className="text-2xl font-light text-charcoal mb-4">
                {treatment.price}
              </p>

              {/* Description */}
              <p className="text-greige text-sm font-light leading-relaxed mb-8 max-w-xs">
                {treatment.description}
              </p>

              {/* Button */}
              <Link
                to="/book"
                className="w-full py-3 border border-charcoal/30 text-charcoal text-[11px] font-light tracking-[0.2em] uppercase hover:bg-charcoal hover:text-white hover:border-charcoal transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Select Options
              </Link>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-16">
          <Link
            to="/treatments"
            className="inline-flex items-center gap-3 text-charcoal text-sm font-light tracking-[0.2em] uppercase hover:text-sage transition-colors duration-300 cursor-pointer"
          >
            View Full Treatment Menu
            <span className="w-8 h-px bg-current inline-block"></span>
          </Link>
        </div>
      </div>
    </section>
  );
}
